/* eslint-disable @typescript-eslint/naming-convention */
import 'reflect-metadata';
import {FormElement, FormElementConfiguration} from 'app/entities/form/formElement.entity';
import {Transform, Type} from 'class-transformer';
import {FormElementType} from 'app/entities/enums';
import {CustomDate} from 'app/core/classes/customDate';

//@todo custom form element, maybe inherited from Select?
export class FormElementCustomCalendarRepeat extends FormElement {
  type: FormElementType = 'calendarRepeat';

  @Type(() => FormElementCustomCalendarRepeatConfiguration)
  configuration?: FormElementCustomCalendarRepeatConfiguration = new FormElementCustomCalendarRepeatConfiguration();
}

export class FormElementCustomCalendarRepeatConfiguration extends FormElementConfiguration {
  clearable = true;

  @Type(() => CustomDate)
  @Transform(({value}) => value ? new CustomDate(value) : null)
  date: CustomDate;
}
